import { render, staticRenderFns } from "./ProfileAlerts.vue?vue&type=template&id=1f88cdee&"
import script from "./ProfileAlerts.vue?vue&type=script&lang=js&"
export * from "./ProfileAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1f88cdee', component.options)
    } else {
      api.reload('1f88cdee', component.options)
    }
    module.hot.accept("./ProfileAlerts.vue?vue&type=template&id=1f88cdee&", function () {
      api.rerender('1f88cdee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/alerts/ProfileAlerts.vue"
export default component.exports